import { Link } from 'react-router-dom'
import logo from '../assets/logo.svg'

function Privacy() {
  return (
    <div className="privacy">
      <Link to="/" className="privacy-logo-link">
        <img src={logo} alt="Call Mom" className="privacy-logo" />
      </Link>

      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

      <section>
        <h2>Overview</h2>
        <p>
          Call Mom is a peer-to-peer video calling application. We are committed
          to protecting your privacy and being transparent about how our app works.
        </p>
      </section>

      <section>
        <h2>Data Collection</h2>
        <p>
          <strong>We do not collect, store, or process any of your personal data.</strong>
        </p>
        <ul>
          <li>Video and audio streams are transmitted directly between participants (peer-to-peer)</li>
          <li>No call recordings are made</li>
        </ul>
      </section>

      <section>
        <h2>Camera & Microphone</h2>
        <p>
          This app requires access to your camera and microphone to enable video calls.
          This access is only used during active calls and is never recorded or transmitted
          to any server. You can revoke these permissions at any time through your browser settings.
        </p>
      </section>

      <section>
        <h2>Authentication</h2>
        <p>
          If you sign in with Google, we only receive your display name and
          profile picture to show during calls. We do not access any other account information.
        </p>
      </section>

      <section>
        <h2>Third-Party Services</h2>
        <p>We use the following third-party services:</p>
        <ul>
          <li><strong>PeerJS</strong> - For WebRTC signaling (connection establishment only)</li>
          <li><strong>STUN/TURN servers</strong> - To help establish peer connections</li>
          <li><strong>Firebase Authentication</strong> - For sign-in</li>
        </ul>
      </section>

      <Link to="/" className="back-link">Back to Home</Link>
    </div>
  )
}

export default Privacy
